import { render, staticRenderFns } from "./p36.vue?vue&type=template&id=56d363ec&scoped=true&"
import script from "./p36.vue?vue&type=script&lang=js&"
export * from "./p36.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d363ec",
  null
  
)

export default component.exports